/**
 * @desc 财务画像-财务造假分析-财务舞弊动机
 * @author caoyx
 */
import styles from '../common.scss';
import React, { PureComponent } from 'react';
import { Table } from 'antd';
import GroupBox from '../../../common/groupBox/GroupBox';
import { PAGE_SIZE } from '../../../../constants/common';
import {addDataIndex} from '../../../../utils/util';
import {queryFraudMotive} from '../../../../services/financialPicture/fraudAnalysis';
import {commonRequest} from '../../common/commons';

export default class FraudFinance extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            motiveData: [],
            pageSize: 10,
            pageNum: 1,
            motive: false
        };
    }

    componentDidMount() {
        this.fraudMotivePort();
    }

    // 财务舞弊动机
    fraudMotivePort = () => {
        const {pageNum, pageSize} = this.state;
        this.setState({
            motive: true
        });
        queryFraudMotive(commonRequest()).then((data) => {
            data = data || {};
            this.setState({
                motiveData: addDataIndex(data.list || [], pageNum, pageSize),
                motive: false
            });
        }).catch(() => {
            this.setState({
                motive: false
            });
        });
    };

    column = () => {
        return [
            {
                title: '序号',
                dataIndex: 'index'
            },
            {
                title: '舞弊动机',
                dataIndex: 'exName'
            },
            {
                title: '解读',
                dataIndex: 'explain'
            }
        ];
    };

    render() {
        const {motive, motiveData} = this.state;
        const { fraudScoreTypeList = [] } = this.props.data;
        // 处理雷达图数据
        const radarOption = { data: [] };
        fraudScoreTypeList.forEach(item => {
            radarOption.data.push({
                name: item.key,
                value: item.value,
                max: 1
            });
        });

        return (
            <GroupBox
                title="财务舞弊动机"
                className={styles.abnormalOperation}
            >
                <Table
                    bordered
                    loading={motive}
                    rowKey="id"
                    dataSource={motiveData}
                    columns={this.column()}
                    pagination={motiveData.length > PAGE_SIZE}
                />
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/FraudFinance.jsx